import { StorageAreaPackageType } from "../../storage-area/get/types";
import {
  StorageGoodsType,
  StorageMethod,
  StoragePlace,
  StorageTemperatureCondition,
} from "../orders-add/types";

export type PricelistOffersGetByIdBody = {
  id_zamowienie: string | undefined;
  token?: string|null;
};
export type PricelistOffersGetByIdResponse = {
  result: boolean;
  error_code: number;
  payload: PricelistOffersGetByIdPayload;
  errors_debug: string[];
};
export type PricelistOffersGetByIdPayload = {
  id_zamowienie: string;
  numer_zamowienia: string;
  data_zlozenia: Date;
  status_zamowienia: OrderStatus;
  opis_uslugi: string;
  termin_rozpoczecia: Date;
  termin_zakonczenia: Date;
  kraj: string;
  wojewodztwo: string;
  kod_pocztowy: string;
  miasto: string;
  miejsce: StoragePlace;
  skladowanie_plaskie: boolean;
  wysokie_skladowanie: boolean;
  polki: boolean;
  warunek_temperaturowy: StorageTemperatureCondition;
  rodzaj_towaru: StorageGoodsType;
  opis_towaru: string;
  specjalny_sprzet: string;
  dodatkowe_uwagi: string;
  oferty: PricelistOffersGetByIdOffers[];
  uslugi_zamowione: {
    cel_zamowienia: StorageMethod | undefined;
    uslugi_dodatkowe?: (StorageMethod | undefined)[];
    ilosc_dodatkowych: number;
    uslugi_zamowione_id: string;
  };
};

export type PricelistOffersGetByIdOffers = {
  id_oferta: string;
  data_wprowadzenia: Date;
  data_waznosci: Date;
  status_oferty: StatusOfOffer;
  rodzaj_oferty: OfferType;
  notatka_konsultanta: string;
  oferty_podwykonawcy: PricelistOffersGetByIdSubcontractorOffers[];
};
export type PricelistOffersGetByIdSubcontractorOffers = {
  id_magazyn: string;
  magazyn: {
    wykonawca: PricelistOffersGetByIdSubcontractors[];
  };
  id_oferta_podwykonawcy: string;
  status_oferty_podwykonawcy: SubcontractorOffersStatus;
  pozycje_oferty: PricelistOffersGetByIdItems[];
};
export type PricelistOffersGetByIdSubcontractors = {
  id_wykonawca: string;
  nazwa: string;
};
export type PricelistOffersGetByIdItems = {
  id_pozycja_oferty: string;
  Usluga: WarehouseServices;
  cena_docelowa: number|null;
  obiekt: PricelistPackageType | StorageAreaPackageType;
  ilosc: number;
  rozmiarm2: number;
  wymaga_wyceny: boolean;
  cennik: PricelistOffersGetByIdPrices | null;
  szerokosc?: number;
  dlugosc?: number;
  jednostka_dlugosci?: number;
};
export type PricelistOffersGetByIdPrices = {
  id_cennik: string;
  usluga_magazynu: WarehouseServices;
  rodzaj_oferty: OfferType;
  jednostka_rozliczenia: BillingUnit;
  stawka_netto: number;
  wazny_od: Date;
  wazny_do: Date;
  nazwa: string;
  nazwa_na_fakture: string;
};
export enum SubcontractorOffersStatus {
  nie_wymaga_potwierdzenia = 0,
  wymaga_potwierdzenia = 1,
  potwierdzono = 2,
  nie_potwierdzono = 3,
}
export enum OrderStatus {
  Nowe = 0,
  Do_ostatecznej_akceptacji = 1,
  Wstepna_akceptacja = 2,
  Rezygnacja = 3,
  Zaakceptowana = 4,
  Anulowana = 5,
  W_trakcie_realizacji = 6,
  Zrealizowano = 7,
  Weryfikacja_klienta = 8,
}
export enum PricelistPackageType {
  Carton = 0,
  Bigbag = 1,
  Pallet_EUR = 2,
  Pallet_polowa_EUR = 3,
  Other_pallet = 4,
  Other = 5,
}
export enum WarehouseServices {
  Skladowanie = 0,
  Crossdocking = 1,
  Fullfilment = 2,
  Etykietowanie = 3,
  Pakowanie = 4,
  Sortowanie = 5,
  E_commerce = 6,
  Wysylka = 7,
  Inne = 8,
  Przyjecie_towaru = 9,
  Wydanie_towaru = 10,
  DystrybucjaDrobnicowa = 11,
  DystrybucjaPaletowa = 12,
  Komisjonowanie = 13,
  TworzeniePakietowPromocyjnych = 14,
  ObslugaZwrotow = 15,
  Foliowanie = 16,
  ZarzadzaniePustymiOpakowaniami = 17,
  AdministracjaDokumentami = 18,
}
export enum OfferType {
  magazyn_dedykowany = 0,
  multimagazyn = 1,
}
export enum BillingUnit {
  paletodoba = 0,
  paleta = 1,
  paleta_mix = 2,
  etykieta_lub_karton = 3,
  szt_lub_karton = 4,
  m2 = 5,
  m3 = 6,
}
export enum StatusOfOffer {
  nowa = 0,
  konsultowana = 1,
  zaakceptowana = 2,
  rezygnacja = 3,
  anulowanie = 4,
  w_trakcie_wyceny = 5,
  gotowa = 6,
  brak = 7,
  wycofana = 8,
  zatwierdzona = 9,
}
